module.exports = __webpack_public_path__ + "fonts/motiva-sans-bold-italic.60f3884.otf";